import { render, staticRenderFns } from "./PaymentMethodIcon.vue?vue&type=template&id=7058b45c&scoped=true&"
import script from "./PaymentMethodIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodIcon.vue?vue&type=style&index=0&id=7058b45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058b45c",
  null
  
)

export default component.exports